export const average = (data, column) => {
  const nums = data
    .map((r) => parseFloat(r[column]))
    .filter((n) => !isNaN(n));

  if (!nums.length) return null;

  const sum = nums.reduce((a, b) => a + b, 0);

  return sum / nums.length;
};

export const maximum = (data, column) => {
  const nums = data
    .map((r) => parseFloat(r[column]))
    .filter((n) => !isNaN(n));

  if (!nums.length) return null;

  return Math.max(...nums);
};

export const minimum = (data, column) => {
  const nums = data
    .map((r) => parseFloat(r[column]))
    .filter((n) => !isNaN(n));

  if (!nums.length) return null;

  return Math.min(...nums);
};
export function sum(data, column) {
  return data.reduce(
    (total, row) => total + Number(row[column] || 0),
    0
  );
}

export function count(data) {
  return data.length;
}

export function median(data, column) {
  const values = data
    .map(row => Number(row[column]))
    .filter(v => !isNaN(v))
    .sort((a, b) => a - b);

  if (!values.length) return null;

  const middle = Math.floor(values.length / 2);

  return values.length % 2 === 0
    ? (values[middle - 1] + values[middle]) / 2
    : values[middle];
}

export function mode(data, column) {
  const frequency = {};

  data.forEach(row => {
    const value = row[column];
    frequency[value] = (frequency[value] || 0) + 1;
  });

  return Object.entries(frequency)
    .sort((a, b) => b[1] - a[1])[0]?.[0];
}